module.exports = __webpack_public_path__ + "static/media/Badge-blue.8f0916db.png";